<template>
	<v-app-bar flat app color="primary" class="lighttext--text" height="42">
		<v-app-bar-nav-icon class=" d-lg-none lighttext--text" @click.stop="toogleNav()"></v-app-bar-nav-icon>
		<v-toolbar-title v-if="!hideUserDropdown" class="px-4">OFEDL - {{title}}</v-toolbar-title>
		<v-spacer></v-spacer>
		<v-btn v-if="!hideUserDropdown" text color="white" @click="logout()">Sair</v-btn>
	</v-app-bar>
</template>

<script>

import {userKey} from '@/config/global'
import Br from '@/config/barramento.js'

export default{
	name: 'cabecalho',
	components:{},
	props: {
		title: String,
		hideToggle: Boolean,
		hideUserDropdown: Boolean
		},
		computed:{
			icon(){
				return this.$store.state.isMenuVisible ? "fa-angle-left" : "fa-angle-down"
				}
			},

		methods:{
			toogleNav(){
				Br.setNavOpen()
			},

			logout(){
				sessionStorage.removeItem(userKey)
				this.$router.push({ name: 'auth' })
				this.$store.commit('setUser', null)
				
			},
		},
	}

</script>

<style scoped>

</style>